import React from "react";
import {Col, Container, Form, Row} from "react-bootstrap";
import UserDashboardPageUserMenu from "../@@Parts/@Menu";
import UserDashboardPageContent from "../@@Parts/Content";
import {UserDashboardPageContentSection} from "@Pages/@@UserPages/@Dashboard/@@Parts";
import {ButtonComponent, InputComponent} from "@Components/Forms";


import paypallIcon from "./@Icons/paypall.svg";
import bankIcon from "./@Icons/bank.svg";

import IconPhotoS from "./@Icons/icon-photo-s-black.svg";
import IconKeyS from "./@Icons/icon-key-s-black.svg";
import IconEditS from "./@Icons/icon-edit-s-black.svg";
import IconDollarS from "./@Icons/icon-dollar-s-orange.svg";
import IconChartS from "./@Icons/icon-chart-s-orange.svg";

import UserAvatar from "./@Icons/avatar.png";


import "./index.scss";
import {SvgIconComponent} from "@Components/Elements";
import BadgeElementComponent from "@Components/@Elements/@Badges";
import {DashboardInformationCardElementComponent} from "@Components/@Elements/@Cards";


export const UserDashboardProfilePage:React.FC = () => {

    return (
    <Container className={'user-dashboard-page-container'}>
        <Row className={'user-dashboard-page-container__content'}>
                <UserDashboardPageUserMenu />

                <UserDashboardPageContent
                    headingText={'Profile'}
                    descriptionText={'Manage your account settings and preferences'}
                >

                    <UserDashboardPageContentSection
                        sectionName={'user-information'}
                    >

                        <Col xs={12} lg={4} className={'user-profile-avatar-section'}>
                            <Row className={'user-profile-avatar-section__content'}>
                                <Col xs={5} className={'user-profile-avatar-section__avatar-picture'}>
                                    <img src={UserAvatar} alt={''} />
                                    <SvgIconComponent
                                        iconSource={IconPhotoS}
                                        className={'user-profile-avatar-section__avatar-picture__change-avatar-button'}
                                    />
                                </Col>
                                <Col xs={7} className={'user-profile-avatar-section__user-information'}>
                                    <span className={'user-profile-avatar-section__user-information__user-name'}>John Smith</span>
                                    <span className={'user-profile-avatar-section__user-information__user-email'}>johnsmith@mail.com</span>
                                    <BadgeElementComponent
                                        badgeType={'success'} badgeSize={'md'}
                                        badgeText={'Premium member'}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} lg={{span: 7, offset: 1}} className={'user-profile-cta-section'}>
                            <Row className={'user-profile-cta-section__content'}>
                                <Col xs={12} className={'user-profile-cta-section__cta-buttons'}>
                                    <ButtonComponent
                                        text={'Change password'}
                                        type={'flat'} bordered={true} iconLeft={IconKeyS}
                                        buttonDisabled={true}
                                    />
                                    <ButtonComponent
                                        text={'Edit profile'}
                                        iconLeft={IconEditS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                                <Col xs={12} className={'user-profile-cta-section__user-information'}>
                                    <span>Member since: Jan 2024</span>
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-refunds'}
                    >

                        <DashboardInformationCardElementComponent
                            cardIcon={IconDollarS}
                            cardHeaderText={'Total Refunds'}
                            cardContentText={'$2,847'}
                        />

                        <DashboardInformationCardElementComponent
                            cardIcon={IconChartS}
                            cardHeaderText={'Active Claims'}
                            cardContentText={'12'}
                        />

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-personal-data'}
                        sectionHeaderText={'Personal information'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'}>
                            <Row className={'user-dashboard-form-component__content'}>

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'First name'}
                                    cssClasses={['user-first-name-field']}
                                    required={true} disabled={true}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Last name'}
                                    cssClasses={['user-last-name-field']}
                                    required={true} disabled={true}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Email Address'}
                                    cssClasses={['user-email-address-field']}
                                    required={true} disabled={true}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Email Address secondary (optional)'}
                                    cssClasses={['user-secondary-email-address-field']}
                                    disabled={true}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Phone Number'}
                                    cssClasses={['user-phone-number-field']}
                                    required={true} disabled={true}
                                />

                                <Col xs={12} className={'user-dashboard-form-component__submit-form'}>
                                    <ButtonComponent
                                        text={'Save changes'}
                                        type={'primary'}
                                        size={'l'}
                                        buttonDisabled={true}
                                    />
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-address-data'}
                        sectionHeaderText={'Address information'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'}>
                            <Row className={'user-dashboard-form-component__content'}>

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Street Address'}
                                    cssClasses={['user-address-street-field']}
                                    required={true} disabled={true}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Apt., suite, etc'}
                                    cssClasses={['user-address-apartment-number-field']}
                                    required={true} disabled={true}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'Zip / postcode'}
                                    cssClasses={['user-address-postcode-field']}
                                    required={true} disabled={true}
                                />

                                <InputComponent
                                    value={''} setValue={() => ''}
                                    label={'City'}
                                    cssClasses={['user-address-city-field']}
                                    required={true} disabled={true}
                                />

                                {/*<InputComponent*/}
                                {/*    value={''} setValue={() => ''}*/}
                                {/*    label={'Select country'}*/}
                                {/*    cssClasses={['user-address-country-field']} required={true}*/}
                                {/*/>*/}

                                <Col xs={12} className={'user-dashboard-form-component__submit-form'}>
                                    <ButtonComponent
                                        text={'Save changes'}
                                        type={'primary'}
                                        size={'l'}
                                        buttonDisabled={true}
                                    />
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-preferences'}
                        sectionHeaderText={'Preferences'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'}>
                            <Row className={'user-dashboard-form-component__content'}>

                                <Col xs={12} className={'switcher-field-component'}>
                                    <Row className={'switcher-field-component__content'}>
                                        <Col xs={9} lg={10} className={'switcher-field-component__field-texts'}>
                                            <Row className={'switcher-field-component__field-texts__content'}>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-name'}>
                                                    <span>Email Notifications</span>
                                                </Col>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-description'}>
                                                    <span>Receive updates about your claims</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={3} lg={2} className={'switcher-field-component__field-switcher'}>
                                            <Form.Check type={'switch'} />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'switcher-field-component'}>
                                    <Row className={'switcher-field-component__content'}>
                                        <Col xs={9} lg={10} className={'switcher-field-component__field-texts'}>
                                            <Row className={'switcher-field-component__field-texts__content'}>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-name'}>
                                                    <span>SMS Notifications</span>
                                                </Col>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-description'}>
                                                    <span>Get text updates for urgent matters</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={3} lg={2} className={'switcher-field-component__field-switcher'}>
                                            <Form.Check type={'switch'} />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'switcher-field-component'}>
                                    <Row className={'switcher-field-component__content'}>
                                        <Col xs={9} lg={10} className={'switcher-field-component__field-texts'}>
                                            <Row className={'switcher-field-component__field-texts__content'}>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-name'}>
                                                    <span>Dark Mode</span>
                                                </Col>
                                                <Col xs={12} className={'switcher-field-component__field-texts__option-description'}>
                                                    <span>Switch to dark theme</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={3} lg={2} className={'switcher-field-component__field-switcher'}>
                                            <Form.Check type={'switch'} />
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'user-billing-data'}
                        sectionHeaderText={'Billing'}
                    >

                        <Col xs={12} className={'user-dashboard-form-component'}>
                            <Row className={'user-dashboard-form-component__content'}>

                                <Col xs={12} className={'dashboard-option-card-component'}>
                                    <Row className={'dashboard-option-card-component__content'}>
                                        <Col xs={3} xl={1} className={'dashboard-option-card-icon'}>
                                            <SvgIconComponent iconSource={paypallIcon} />
                                        </Col>
                                        <Col xs={9} xl={6} className={'dashboard-option-card-data'}>
                                            <Row className={'dashboard-option-card-data__content'}>
                                                <Col xs={12} className={'dashboard-option-card-data__card-title'}>
                                                    <span>PayPal</span>
                                                </Col>
                                                <Col xs={12} className={'dashboard-option-card-data__card-description'}>
                                                    <span>Payment processing</span>
                                                </Col>
                                                <Col xs={12} className={'dashboard-option-card-data__card-information'}>
                                                    <span className={'option-data-status'}>
                                                        <span>Connected</span>
                                                    </span>
                                                    <span className={'option-data-text'}>Connected 3 months ago</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} xl={5} className={'dashboard-option-card-options'}>
                                            <Row className={'dashboard-option-card-options__content'}>
                                                <ButtonComponent
                                                    text={'Update'}
                                                    type={'flat'}
                                                    size={'l'}
                                                    buttonDisabled={true}
                                                />
                                                <ButtonComponent
                                                    text={'Remove'}
                                                    type={'secondary'}
                                                    size={'l'}
                                                    buttonDisabled={true}
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} className={'dashboard-option-card-component'}>
                                    <Row className={'dashboard-option-card-component__content'}>
                                        <Col xs={3} xl={1} className={'dashboard-option-card-icon'}>
                                            <SvgIconComponent iconSource={bankIcon} />
                                        </Col>
                                        <Col xs={9} xl={6} className={'dashboard-option-card-data'}>
                                            <Row className={'dashboard-option-card-data__content'}>
                                                <Col xs={12} className={'dashboard-option-card-data__card-title'}>
                                                    <span>Chase Bank</span>
                                                </Col>
                                                <Col xs={12} className={'dashboard-option-card-data__card-description'}>
                                                    <span>Account ending in ****4567</span>
                                                </Col>
                                                <Col xs={12} className={'dashboard-option-card-data__card-information'}>
                                                    <span className={'option-data-status'}>
                                                        <span>Connected</span>
                                                    </span>
                                                    <span className={'option-data-text'}>Last verified: 1 week ago</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={12} xl={5} className={'dashboard-option-card-options'}>
                                            <Row className={'dashboard-option-card-options__content'}>
                                                <ButtonComponent
                                                    text={'Manage'}
                                                    type={'flat'}
                                                    size={'l'}
                                                    buttonDisabled={true}
                                                />
                                                <ButtonComponent
                                                    text={'Disconnect'}
                                                    type={'secondary'}
                                                    size={'l'}
                                                    buttonDisabled={true}
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>

                    <UserDashboardPageContentSection
                        sectionName={'delete-account'}
                    >

                        <Col xs={9} className={'delete-account-heading-text'}>
                            <span>Delete account</span>
                        </Col>

                        <Col xs={3} className={'delete-account-submit-button'}>
                            <ButtonComponent text={'Delete'} type={'flat'} buttonDisabled={true} />
                        </Col>

                    </UserDashboardPageContentSection>

                </UserDashboardPageContent>
        </Row>
        </Container>
    );

};


export default UserDashboardProfilePage;
